import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import { Select } from "../../Common";
import Routes from "../../../routes";
import { TranslateW } from '../../../Utils/Languages/Translate';

// LocationDropdown With SubLocations
const LocationDropdown = ({ 
  locations,
  location,
  subLocation,
  onChangeLocation,
  onChangeSubLocation,
  ErrorObject,
  disabled,
  variant
}) => {

  const [subLocations, setSubLocations] = useState([]);

  const handleLocationChange = async (e) => {
    onChangeLocation(e.target.value);

    if (onChangeSubLocation) {
      getSubLocations(e.target.value);
    }
  };

  const getSubLocations = async (locationId) => {
    try {
      const response = await fetch(Routes.Location.SubLocations(locationId));
      const data = await response.json();
      setSubLocations(data);
    } catch (error) {
      console.error("Error fetching subLocations:", error);
    }
  };

  return (
    <>
      <Grid item xs={12} sm={6} md={6} lg={6}>
        <Select
          required
          disabled={disabled}
          value={location}
          label= {TranslateW("assetDetailsDashboardTab.location")}
          options={locations}
          variant={variant}
          onChange={handleLocationChange}
          error={ErrorObject}
        />
      </Grid>
      {(subLocations.length > 0 && location && onChangeSubLocation) && (
        <Grid item xs={12} sm={6} md={6} lg={6}>
          <Select
            value={subLocation}
            disabled={disabled}
            label= {TranslateW("assetDetailsMainTab.subLocation")}
            options={subLocations.map((subLoc) => ({
              value: subLoc.id,
              label: subLoc.shortName,
            }))}
            onChange={(e) => onChangeSubLocation(e.target.value)}
          />
        </Grid>
      )}
    </>
  );
};


export default LocationDropdown;